import { render, staticRenderFns } from "./selector.vue?vue&type=template&id=6536bd90&scoped=true"
import script from "./selector.vue?vue&type=script&lang=js"
export * from "./selector.vue?vue&type=script&lang=js"
import style0 from "./selector.vue?vue&type=style&index=0&id=6536bd90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6536bd90",
  null
  
)

export default component.exports